"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryType = exports.ComplianceCategoryIdMapping = exports.CreateOrUpdateCategory = exports.CreateOrUpdateBaseCategory = void 0;
const mobx_1 = require("mobx");
class CreateOrUpdateBaseCategory {
    constructor() {
        this.name = '';
        this.categoryType = CategoryType.STANDARD;
        this.industryTypeIds = [];
    }
}
exports.CreateOrUpdateBaseCategory = CreateOrUpdateBaseCategory;
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "name", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "colorHex", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "parentCategoryId", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "complianceCategoryId", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "wooCommerceCategoryId", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "leaflyCategory", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "categoryType", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "measurementType", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "exitLabel", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "lowInventoryThreshold", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "cannabisCategory", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "cannabisType", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "isActive", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "industryTypeIds", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "defaultMinimumAge", void 0);
__decorate([
    mobx_1.observable
], CreateOrUpdateBaseCategory.prototype, "categoryLocationOverrides", void 0);
class CreateOrUpdateCategory extends CreateOrUpdateBaseCategory {
    constructor() {
        super();
        this.childCategories = [];
        (0, mobx_1.observe)(this, (change) => {
            // All nested categories will have the same inherited values as the parent
            const inheritableAttrs = ['colorHex', 'complianceCategoryId', 'industryTypeIds'];
            if (inheritableAttrs.includes(String(change.name))) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.childCategories.forEach((childCategory) => {
                    childCategory[change.name] =
                        (change.type === 'update' || change.type === 'add') && change.newValue;
                });
            }
        });
    }
}
exports.CreateOrUpdateCategory = CreateOrUpdateCategory;
__decorate([
    mobx_1.observable
], CreateOrUpdateCategory.prototype, "childCategories", void 0);
var ComplianceCategoryIdMapping;
(function (ComplianceCategoryIdMapping) {
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["SEED"] = 1] = "SEED";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["PLANTS"] = 2] = "PLANTS";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["DRIED"] = 3] = "DRIED";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["OIL"] = 4] = "OIL";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["FRESH_CANNABIS"] = 5] = "FRESH_CANNABIS";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["AGCO_ACCESSORY"] = 6] = "AGCO_ACCESSORY";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["EDIBLES_SOLIDS"] = 7] = "EDIBLES_SOLIDS";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["EDIBLES_NON_SOLIDS"] = 8] = "EDIBLES_NON_SOLIDS";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["EXTRACTS_INHALED"] = 9] = "EXTRACTS_INHALED";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["EXTRACTS_INGESTED"] = 10] = "EXTRACTS_INGESTED";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["EXTRACTS_OTHERS"] = 11] = "EXTRACTS_OTHERS";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["TOPICALS"] = 12] = "TOPICALS";
})(ComplianceCategoryIdMapping || (exports.ComplianceCategoryIdMapping = ComplianceCategoryIdMapping = {}));
var CategoryType;
(function (CategoryType) {
    CategoryType["STANDARD"] = "standard";
    CategoryType["SYSTEM_FEES"] = "systemFees";
})(CategoryType || (exports.CategoryType = CategoryType = {}));
//# sourceMappingURL=models.js.map